import md5 from 'js-md5';

/**
 * 生成 UUID（不含中划线）- 浏览器环境
 * @returns {string} 32位小写十六进制字符串
 */
function generateUuid() {
    // 生成随机的 16 字节数据
    const randomValues = new Uint8Array(16);
    if (window.crypto && window.crypto.getRandomValues) {
        window.crypto.getRandomValues(randomValues);
    } else {
        // 降级方案
        for (let i = 0; i < 16; i++) {
            randomValues[i] = Math.floor(Math.random() * 256);
        }
    }
    // 转换为十六进制字符串
    return Array.from(randomValues)
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
}

/**
 * 根据传入的 URL 返回加密后的（带鉴权参数的）URL。
 * 生成阿里云 CDN URL 鉴权（简单基于 MD5 的 URL token）。
 * 
 * @param {string} url - 原始 URL
 * @param {object} options - 配置选项
 * @param {string} options.key - 鉴权用的私钥（默认："zjz_jdy_cdn"）
 * @param {string} options.paramName - URL 中附加的鉴权参数名（默认："auth_key"）
 * @param {boolean} options.includeQueryInSign - 签名时是否包含原始 URL 的 query 部分（默认：false，仅签 path）
 * @param {string} options.cdnDomain - CDN 域名（默认：""）
 * @returns {string} 带鉴权参数的 URL 字符串
 */
export function signUrl(url, options) {
    options = options || {};
    if (!url) {
        return "";
    }
    if (options.cdnDomain) {

        // 替换 URL 中的域名为 cdnDomain
        const parsedUrl = new URL(url);
        parsedUrl.host = options.cdnDomain;
        url = parsedUrl.toString();
    }

    // 默认配置
    const key = options.key || "zjz_jdy_cdn";
    const paramName = options.paramName || "auth_key";
    const includeQueryInSign = Boolean(options.includeQueryInSign);

    // 生成不含中划线的随机串
    const nonce = generateUuid();
    const expireAfter = Math.floor(Date.now() / 1000);

    // 解析 URL
    const parsedUrl = new URL(url);
    
    // 组合用于签名的资源部分（path 或 path + query）
    let resource = parsedUrl.pathname;
    if (includeQueryInSign && parsedUrl.search) {
        resource = resource + parsedUrl.search;
    }

    // 构建签名字符串
    const toSign = resource + "-" + expireAfter + "-" + nonce + "-0-" + key;
    
    // 使用 js-md5 生成 MD5 签名
    const sig = md5(toSign);

    // 鉴权参数值为: <expire>-<nonce>-0-<sig>
    const authValue = expireAfter + "-" + nonce + "-0-" + sig;

    // 将鉴权参数附加到原始 URL 的 query 中（保留已有参数）
    parsedUrl.searchParams.append(paramName, authValue);

    return parsedUrl.toString();
}

// 默认导出
export default {
    signUrl
};

